import React from "react";
import Insta from "../assets/svgs/instagram.svg";
import Tiktok from "../assets/svgs/tiktok.svg";
import Youtube from "../assets/svgs/youtube.svg";

const Social = () => {
  return (
    <div className="flex gap-4 justify-center items-center my-2">
      <a href="#">
        <img
          src={Youtube}
          alt="Youtube"
          className="size-10"
        />
      </a>
      <a href="#">
        <img
          src={Insta}
          alt="instagram"
          className="size-9"
        />
      </a>
      <a href="#">
        <img
          src={Tiktok}
          alt="Tiktok"
          className="size-9"
        />
      </a>
    </div>
  );
};

export default Social;
